import React from 'react'
import { array, object, string } from 'prop-types'
import styles from './TimelineView.module.scss'
import Stack from '@/component/Primitive/Stack'
import cx from 'classnames'
import Timeline from '@/component/Primitive/Events/components/EventAgendaNavigator/components/Timeline/Timeline'

export const TimelineView = ({
  agendaItemDayMap,
  backgroundImage,
  currentDateItem,
  event,
  selectedDay,
  sortedAgenda,
  theme,
  timezoneAbbreviation
}) => {
  return (
    <div className={cx(styles.EventAgenda, theme === 'dark' && styles.dark)}>
      {backgroundImage && (
        <div
          className={styles.EventAgendaImage}
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}
      <Stack>
        <Stack gap="small">
          <Timeline
            event={event}
            sortedAgenda={sortedAgenda}
            agendaItemDayMap={agendaItemDayMap}
            selectedDay={selectedDay}
            currentDateItem={currentDateItem}
            timezoneAbbreviation={timezoneAbbreviation}
          />
        </Stack>
      </Stack>
    </div>
  )
}

TimelineView.propTypes = {
  agendaItemDayMap: object,
  backgroundImage: object,
  currentDateItem: object,
  event: object,
  selectedDay: string,
  sortedAgenda: array,
  theme: string
}
